<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
    <BottomNav />
  </v-app>
</template>

<script>
import BottomNav from "./components/BottomNav";

export default {
  name: "App",

  components: {
    BottomNav
  },
  data: () => ({}),
  created() {
    try {
      // NOTE: 45min refresh policy is what google recommends
      window.setInterval(this.$refreshToken(), 2.7e6);
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
